import React from 'react';
import ReactDOM from 'react-dom/client';
import 'antd/dist/reset.css';
import './index.css';
import './App.css';
import App from './App';
import { initGoogleAnalyticsProd } from './initGoogleAnalytics';

initGoogleAnalyticsProd();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 